import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBlogPosts, getSettings } from '../services/api';

const MagazineSection = () => {
  const [posts, setPosts] = useState([]);
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [postsRes, settingsRes] = await Promise.all([
          getBlogPosts(),
          getSettings()
        ]);
        setPosts((postsRes.data || []).slice(0, 4));
        setVisible(settingsRes.data?.blogVisible !== false);
      } catch (err) {
        console.error('Blog fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (!visible || loading || posts.length === 0) return null;

  return (
    <section className="py-12 md:py-16 bg-white" id="magazine">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B1B1B] mb-8" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          İlham & Rehber
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              data-testid={`magazine-card-${post.slug}`}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={post.image || 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80'}
                alt={post.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-white/70 text-xs uppercase tracking-wider mb-1 block">{post.category}</span>
                <h3
                  className="text-white font-bold text-lg line-clamp-2"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {post.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MagazineSection;
